// extracted by mini-css-extract-plugin
export default {"pagination":"D8WW6HDnkKOTfMUkRRDB","current":"eAwysKAX1c15GSX3rqHz","disabled":"Q9p0dxoZBwAutdZxusOz"};